import { API } from '@/config';

import {
  FILL_LIST, FILL_ONE, SET_DETECTION_OF_CHANGES,
} from './mutation-types';

export default {
  async getList({ commit }) {
    try {
      const list = (await API.get('/widgets')).data.data;
      commit(FILL_LIST, { list });
    } catch (error) {
      console.log(error);
    }
  },

  async getOne({ commit }, id) {
    try {
      const one = (await API.get(`/widget?id=${id}`)).data.data;
      commit(FILL_ONE, { one });
      commit(SET_DETECTION_OF_CHANGES, { haveAnyChangesBeenDetected: false });
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },

  updateWidget({ commit }, params) {
    const options = {
      detectChanges: true,
      ...params,
    };
    commit(FILL_ONE, { one: params.newWidgetDetails });
    if (options.detectChanges) commit(SET_DETECTION_OF_CHANGES, { haveAnyChangesBeenDetected: true });
  },

  async saveConfiguration({ commit, state }, id) {
    try {
      await API.post(`/widget?id=${id}`, { ...state.one });
      commit(SET_DETECTION_OF_CHANGES, { haveAnyChangesBeenDetected: false });
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },

  async toggleWidgetActivity(context, payload) {
    try {
      const { id, isActive } = payload;
      await API.post('/widget/status', { id, isActive });
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },

  async create() {
    try {
      const { id } = (await API.put('/widget')).data.data;
      return id;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  async duplicate(context, payload) {
    try {
      const { widgetId } = payload;
      const { id } = (await API.post(`/widget/duplicate?id=${widgetId}`)).data.data;
      return id;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  async delete(context, payload) {
    try {
      const { id } = payload;
      await API.delete(`/widget?id=${id}`);
    } catch (error) {
      console.log(error);
    }
  },

  cancelDetectedChanges({ commit }) {
    commit(SET_DETECTION_OF_CHANGES, { haveAnyChangesBeenDetected: false });
  },

  async assignAgent(context, params) {
    try {
      await API.post('/widget/assignAgent', params);
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },
};
